import { render, staticRenderFns } from "./OptionInfoModal.vue?vue&type=template&id=2be1284a&scoped=true"
import script from "./OptionInfoModal.vue?vue&type=script&lang=js"
export * from "./OptionInfoModal.vue?vue&type=script&lang=js"
import style0 from "./OptionInfoModal.vue?vue&type=style&index=0&id=2be1284a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1284a",
  null
  
)

export default component.exports